import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const RegisterWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 770px;
  transition: all 0.3s ease;
  margin: 15px auto;

  @media (max-width: 768px) {
    margin: 5px auto;
    padding: 10px;
    border-radius: 12px;
  }
`;
